// extracted by mini-css-extract-plugin
export default {"icon":"_1sjge0j"};